import { METHOD_TYPES } from 'utils/constants/index'
import axiosInstanceService, { microServices } from 'network/apis/index'

export const getPreviousRoundState = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'game/fast/mine/unfinished-bet-state', {}, {
    server: microServices.SERVICE_URL_1
  })
}

export const getLiveStats = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'game/fast/mine/live-stats', {}, {
    server: microServices.SERVICE_URL_1
  })
}

export const getBetHistory = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'game/fast/mine/my-bets', {}, {
    server: microServices.SERVICE_URL_1,
    params
  })
}

export const placeBet = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'game/fast/mine/place-bet', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const autoBet = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'game/fast/mine/place-auto-bet', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const openTile = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'game/fast/mine/open-tile', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const cashOutBet = () => {
  return axiosInstanceService(METHOD_TYPES.post, 'game/fast/mine/cashout-bet', {}, {
    server: microServices.SERVICE_URL_1
  })
}

export const verifyProvableFairMine = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'game/fast/mine/check-provable-fair', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const getTopBets = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'game/fast/mine/top-bets', {}, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const mineCheckFairness = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, 'game/fast/mine/check-fairness', data, {
    server: microServices.USER_URL
  })
}
